import React from 'react'
import TimePicker from '../../pb_time_picker/_time_picker'

const TimePickerDefault = (props) => (
  <div>
    <TimePicker
        id="time-picker-default"
        {...props}
    />
  </div>
)

export default TimePickerDefault
